import { motion, useReducedMotion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { VenuePortal } from './VenuePortal'

export function HomeHero() {
  const shouldReduceMotion = useReducedMotion()
  const { t } = useTranslation('home')
  const ease = [0.22, 1, 0.36, 1] as const

  return (
    <section className="relative flex h-screen w-full flex-col overflow-hidden bg-paper">
      {/* Top text area */}
      <div className="flex shrink-0 flex-col items-center justify-center px-4 pb-6 pt-24 text-center md:pb-8 md:pt-28">
        <motion.h1
          initial={shouldReduceMotion ? undefined : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.05, ease }}
          className="font-display text-[clamp(2.75rem,8vw,6rem)] font-extrabold leading-[0.95] tracking-tight text-ink"
        >
          {t('hero.title')}
        </motion.h1>
        <motion.p
          initial={shouldReduceMotion ? undefined : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15, ease }}
          className="mt-4 max-w-2xl text-lg font-medium leading-relaxed text-muted md:text-xl"
        >
          {t('hero.subtitle')}
        </motion.p>
      </div>

      {/* Venue portal menu */}
      <div className="min-h-0 flex-1">
        <VenuePortal direction="row" />
      </div>

      {/* Bottom decorative rule */}
      <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-maia via-bar to-pizza" />
    </section>
  )
}
